module.exports = __webpack_public_path__ + "static/img/icon-form-m_05.2ad13d11.svg";